import React, { useState, useRef, useEffect } from "react";
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  StyleSheet,
  Modal,
  ScrollView,
} from "react-native";

import { observer, Observer } from "mobx-react";

import Fonts from "../../Resources/Fonts";
import Colors from "../../Resources/Color";
import GlobalStyles from "../../Resources/Styles";
import Block from "../Firestore/Block";

import { v4 as uuidv4 } from "uuid";
import { useScreenDimensions, useDevice } from "../_layout";
import Workout from "../Firestore/Workout";

import { useTranslation } from "react-i18next";
import { ProtocolCases, ProtocolTitles } from "../../Resources/Constants";
import { Ionicons } from "@expo/vector-icons";
import Tooltip from "../Components/Tooltip";

const AddBlockView = observer(
  ({ isVisible, onClose, block, client, coach }) => {
    const { t, i18n } = useTranslation();

    const { screenSize } = useScreenDimensions();
    const { isMobile } = useDevice();

    const [blockName, setBlockName] = useState(
      block && block.name ? block.name : ""
    );
    const predefinedText =
      block && block.name ? block.name : t("newBlock-string");

    const text = block ? "editBlock-string" : "createBlock-string";

    const [number, setNumber] = useState(
      block && block.totalWeeks ? block.totalWeeks : null
    );

    const [labelName, setLabelName] = useState(
      block && block.label ? block.label : ""
    );

    const [isNameHovered, setIsNameHovered] = useState(false);
    const [isWeeksHovered, setIsWeeksHovered] = useState(false);
    const [isLabelHovered, setIsLabelHovered] = useState(false);

    const blockNameInputRef = useRef(null);

    useEffect(() => {
      if (isVisible && blockNameInputRef.current) {
        // Small delay to ensure modal is fully rendered
        setTimeout(() => {
          blockNameInputRef.current?.focus();
        }, 100);
      }
    }, [isVisible]);

    const handleChangeWeek = (text) => {
      // If the field is cleared, reset the number
      if (text === "") {
        setNumber(null);
        return;
      }
      const parsedNumber = parseInt(text, 10);
      // Only update for valid 1–24; ignore invalid entries to keep the previous value
      if (!isNaN(parsedNumber) && parsedNumber > 0 && parsedNumber <= 24) {
        setNumber(parsedNumber);
      }
    };

    const cancel = () => {
      setBlockName(block ? block.name : "");
      setNumber(null);
      onClose();
    };

    const handleKeyPress = (e) => {
      if (e.key === "Enter" || e.keyCode === 13) {
        handleSave();
      }
    };

    const handleSave = () => {
      const newName = blockName === "" ? predefinedText : blockName;
      if (!block) {
        if (client) {
          const newBlock = new Block(
            uuidv4(),
            newName,
            "",
            [],
            false,
            false,
            client,
            1,
            number ? number : 6,
            labelName
          );
          const newWorkout = new Workout(
            uuidv4(),
            null,
            i18n.language === "es" ? "Día 1" : "Day 1",
            0,
            1,
            false,
            newBlock,
            []
          );
          // newBlock.setProperty("isShowingDashboard", true);
          newBlock.workouts.push(newWorkout);
          newBlock.toggleProtocolSeriesShown(
            ProtocolTitles.PRIMARY_BENCH_PRESS
          );
          newBlock.toggleProtocolSeriesShown(ProtocolTitles.PRIMARY_DEADLIFT);
          newBlock.toggleProtocolSeriesShown(ProtocolTitles.PRIMARY_SQUAT);

          client.blocks.push(newBlock);

          client.updateClientTransactionData(newBlock.id);
          client.startOrResetBatchTimer();
        } else {
          if (coach) {
            const newBlock = new Block(
              uuidv4(),
              newName,
              "",
              [],
              false,
              false,
              null,
              1,
              number ? number : 6,
              labelName,
              undefined,
              coach
            );
            const newWorkout = new Workout(
              uuidv4(),
              null,
              i18n.language === "es" ? "Día 1" : "Day 1",
              0,
              1,
              false,
              newBlock,
              []
            );
            // newBlock.setProperty("isShowingDashboard", true);
            newBlock.toggleProtocolSeriesShown(
              ProtocolTitles.PRIMARY_BENCH_PRESS
            );
            newBlock.toggleProtocolSeriesShown(ProtocolTitles.PRIMARY_DEADLIFT);
            newBlock.toggleProtocolSeriesShown(ProtocolTitles.PRIMARY_SQUAT);
            newBlock.workouts.push(newWorkout);

            coach.blockLibrary.push(newBlock);

            coach.updateCoachTransactionBlocks(newBlock.id);
            coach.startOrResetBatchTimer();
          }
        }
      } else {
        block.setProperty("name", newName);
        block.setProperty("totalWeeks", number ? number : 6);
        block.setProperty("label", labelName);
      }
      onClose();
    };

    const Buttons = ({ bool }) => {
      const text = bool ? "save-string" : "cancel-string";

      const [isHovered, setIsHovered] = useState(false);

      const Save = () => {
        handleSave();
      };

      return bool ? (
        <TouchableOpacity
          onPress={Save}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={{
              // marginHorizontal: 20,
              backgroundColor: Colors.bubbleColor,
              borderRadius: 14,
              borderWidth: 1,
              justifyContent: "center",
              borderColor: Colors.bubbleColor,
              width: 80,
              height: 35,
              justifyContent: "center",
              alignItems: "center",
              opacity: isHovered ? 0.8 : 1,
            }}
          >
            <Text
              style={{
                textAlignVertical: "center",
                textAlign: "center",
                color: Colors.whiteColor,
              }}
            >
              {t(text)}
            </Text>
          </View>
        </TouchableOpacity>
      ) : (
        <TouchableOpacity
          onPress={cancel}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={{
              // marginHorizontal: 20,
              backgroundColor: isHovered ? Colors.redColor : Colors.whiteColor,
              borderRadius: 14,
              borderWidth: 1,
              justifyContent: "center",
              borderColor: "red",
              width: 80,
              height: 35,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text
              style={{
                textAlignVertical: "center",
                textAlign: "center",
                color: isHovered ? "white" : Colors.redColor,
              }}
            >
              {t(text)}
            </Text>
          </View>
        </TouchableOpacity>
      );
    };

    const LabelRowButton = ({ label }) => {
      const isSelected =
        label.toLowerCase() === labelName.toLowerCase() ? true : false;

      const select = () => {
        if (isSelected) {
          console.log("sadd");
        } else {
          setLabelName(label);
          // block.setProperty("label", labelName);
        }
      };

      const [isHovered, setIsHovered] = useState(false);

      return (
        <TouchableOpacity
          onPress={select}
          style={{ maxWidth: "100%" }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={[
              styles.AttributeButton,
              {
                backgroundColor: isHovered
                  ? "rgba(63, 123, 141, 0.65)"
                  : isSelected
                  ? Colors.bubbleColor
                  : Colors.whiteColor,

                borderColor: isHovered
                  ? "rgba(63, 123, 141, 0.65)"
                  : isSelected
                  ? Colors.bubbleColor
                  : Colors.grayColor,
                flexDirection: "row",
                alignItems: "center",
              },
            ]}
          >
            <Text
              style={{
                fontSize: 12,
                padding: 5,
                color:
                  isSelected || isHovered
                    ? Colors.whiteColor
                    : Colors.grayColor,
                width: "100%",
              }}
            >
              {label}
            </Text>
          </View>
        </TouchableOpacity>
      );
    };

    return (
      <Modal
        animationType="fade"
        transparent={true}
        visible={isVisible}
        onRequestClose={onClose}
      >
        <View style={GlobalStyles.centeredView}>
          <TouchableOpacity
            onPress={onClose}
            style={GlobalStyles.touchableBackground}
          >
            <View />
          </TouchableOpacity>
          <View
            style={{
              position: "absolute",
              maxHeight: "90%",
              maxWidth: "90%",
            }}
            onStartShouldSetResponder={() => false}
          >
            <View
              style={[
                styles.modalView,
                {
                  width: 400,
                  flexShrink: 1,
                },
              ]}
            >
              <ScrollView
                showsVerticalScrollIndicator={false}
                style={{ width: "100%", maxHeight: "100%" }}
                contentContainerStyle={{
                  alignItems: "center",
                  justifyContent: "center",
                  flexGrow: 1,
                }}
              >
                <View
                  style={{
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Text style={Fonts.bold18Centered}>{t(text)}</Text>
                  <TextInput
                    ref={blockNameInputRef}
                    style={[
                      GlobalStyles.textInputStyle,
                      {
                        borderRadius: 10,
                        borderColor: isNameHovered
                          ? "rgba(0, 0, 0, 0.5)"
                          : Colors.borderColor,
                        fontSize: isMobile ? 16 : undefined,
                      },
                    ]}
                    placeholder={predefinedText}
                    placeholderTextColor={Colors.grayColor}
                    value={blockName}
                    onChangeText={setBlockName}
                    maxLength={40}
                    onMouseEnter={() => !isMobile && setIsNameHovered(true)}
                    onMouseLeave={() => setIsNameHovered(false)}
                    onKeyPress={handleKeyPress}
                  />

                  <View
                    style={[
                      GlobalStyles.HStack,
                      {
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginTop: 8,
                        width: "100%",
                      },
                    ]}
                  >
                    <Text style={[Fonts.medium14, {}]}>
                      {t("weeksDots-string")}
                    </Text>

                    <TextInput
                      style={[
                        styles.textInputStyle,
                        {
                          borderColor: isWeeksHovered
                            ? "rgba(0, 0, 0, 0.5)"
                            : Colors.borderColor,
                          fontSize: isMobile ? 16 : undefined,
                        },
                      ]}
                      placeholder={"6"}
                      placeholderTextColor={Colors.grayColor}
                      value={number !== null ? number.toString() : ""}
                      onChangeText={handleChangeWeek}
                      maxLength={2}
                      onMouseEnter={() => !isMobile && setIsWeeksHovered(true)}
                      onMouseLeave={() => setIsWeeksHovered(false)}
                      onKeyPress={handleKeyPress}
                    />
                  </View>

                  {client && (
                    <View style={{ width: "100%", marginTop: 10 }}>
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginBottom: 8,
                        }}
                      >
                        <View
                          style={{
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 4,
                          }}
                        >
                          <Text style={Fonts.medium14}>
                            {t("label-string")}
                          </Text>
                          <Tooltip
                            content="macrocycleTooltip-string"
                            placement="top"
                            maxWidth={300}
                          >
                            <View style={{ padding: 2, marginBottom: -1 }}>
                              <Ionicons
                                name="information-circle-outline"
                                size={14}
                                color={Colors.grayColor}
                              />
                            </View>
                          </Tooltip>
                        </View>
                        <Text style={{ fontSize: 12, color: Colors.grayColor }}>
                          {t("optional-string")}
                        </Text>
                      </View>
                      <View
                        style={{
                          width: "100%",
                          borderColor: isLabelHovered
                            ? "rgba(0, 0, 0, 0.5)"
                            : Colors.borderColor,
                          backgroundColor: Colors.whiteColor,
                          borderWidth: 0.1,
                          borderRadius: 10,
                        }}
                        onMouseEnter={() =>
                          !isMobile && setIsLabelHovered(true)
                        }
                        onMouseLeave={() => setIsLabelHovered(false)}
                      >
                        <TextInput
                          style={{
                            height: 40,
                            color: Colors.blackColor,
                            padding: 10,
                            outlineStyle: "none",
                            fontSize: isMobile ? 16 : undefined,
                          }}
                          placeholder={t("macrocyclePlaceholder-string")}
                          placeholderTextColor={Colors.grayColor}
                          value={labelName}
                          onChangeText={(text) => setLabelName(text)}
                          maxLength={20}
                          onKeyPress={handleKeyPress}
                        />

                        <Observer>
                          {() => (
                            <>
                              {client.getFilteredLabels(labelName).length >
                              0 ? (
                                <>
                                  <View
                                    style={{
                                      height: 0.1,
                                      backgroundColor: "rgba(0,0,0,0.2)",
                                      width: "90%",
                                      alignSelf: "center",
                                      marginTop: 5,
                                    }}
                                  />
                                  <View
                                    style={{
                                      // maxHeight: 40,
                                      // paddingLeft: 5,
                                      flexDirection: "row",
                                      flexWrap: "wrap",
                                      alignItems: "center",
                                      gap: 8,
                                      margin: 8,
                                    }}
                                  >
                                    {client
                                      .getFilteredLabels(labelName)
                                      .map((label, index) => (
                                        <LabelRowButton
                                          label={label}
                                          key={index}
                                        />
                                      ))}
                                  </View>
                                </>
                              ) : (
                                <>
                                  {labelName !== "" && (
                                    <>
                                      <View
                                        style={{
                                          height: 0.1,
                                          backgroundColor: "rgba(0,0,0,0.2)",
                                          width: "90%",
                                          alignSelf: "center",
                                          marginTop: 5,
                                        }}
                                      />
                                      <Text
                                        style={{
                                          alignSelf: "center",
                                          textAlign: "center",
                                          color: "rgba(0, 0, 0, 0.3)",
                                          paddingVertical: 10,
                                          paddingHorizontal: 20,
                                        }}
                                      >
                                        {t("labelEmptyText-string")}
                                      </Text>
                                    </>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </Observer>
                      </View>
                    </View>
                  )}
                </View>
                <View
                  style={[
                    GlobalStyles.HStack,
                    {
                      justifyContent: "center",
                      width: "100%",
                      justifyContent: "space-around",
                      marginTop: 16,
                    },
                  ]}
                >
                  <Buttons bool={false} />
                  <Buttons bool={true} />
                </View>
              </ScrollView>
            </View>
          </View>
        </View>
      </Modal>
    );
  }
);

const styles = StyleSheet.create({
  modalView: {
    backgroundColor: Colors.whiteColor,
    borderRadius: 18,
    paddingHorizontal: 24,
    paddingVertical: 24,
    alignItems: "center",
    justifyContent: "space-between",
    maxHeight: "100%",
    maxWidth: "100%",
  },
  textInputStyle: {
    width: "40%",
    height: 40,
    borderColor: Colors.borderColor,
    backgroundColor: Colors.whiteColor,
    color: Colors.blackColor,
    borderWidth: 0.1,
    padding: 10,
    borderRadius: 10,
    outlineStyle: "none",
  },
  textInputStyleLabel: {
    width: "60%",
    height: 40,
    borderColor: Colors.borderColor,
    backgroundColor: Colors.whiteColor,
    color: Colors.blackColor,
    borderWidth: 0.1,
    padding: 10,
    borderRadius: 10,
    outlineStyle: "none",
  },
  arrowsContainer: {
    width: 40,
    height: 40,
    backgroundColor: Colors.backgroundColor,
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: 10,
    marginLeft: 5,
  },
  arrowText: {
    fontSize: 18,
    color: Colors.blackColor,
  },
  searchBar: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 10,
    borderRadius: 14,
    height: 40,
  },
  textInputSB: {
    flex: 1,
    paddingHorizontal: 10,
    borderRadius: 14,
    borderWidth: 0,
    fontWeight: "400",
    fontSize: 14,
  },
  AttributeButton: {
    borderRadius: 8,
    borderWidth: 0.5,
    borderColor: Colors.borderColor,
  },
});

export default AddBlockView;
